import React from 'react';
import { Box, Button, Grid, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';
import * as XLSX from 'xlsx';
import useProjectCountChartData from 'hooks/consume_api/query/useProjectCountChartData';

interface Props {
    division: string;
    district: string;
    upazila: string;
    union: string;
}

const ProjectCountTable: React.FC<Props> = ({ division, district, upazila, union }) => {
    const { data } = useProjectCountChartData();
    console.log("ProjectCountTable==", data);

    const handleExport = () => {
        // Prepare data for export
        const tableData = data?.data?.map((item: any) => ({
            "No. of Project Count": item.project_count,
            "Male": item.male || 0,
            "Female": item.female || 0,
            "Total": item.total || 0,
            "Youth": item.youth || 0,
            "Women headed": item.women_headed || 0,
            "Ethnic": item.ethnic || 0
        })) || [];

        const ws = XLSX.utils.json_to_sheet(tableData);
        const wb = XLSX.utils.book_new();

        XLSX.utils.book_append_sheet(wb, ws, 'Project Count Data');
        XLSX.writeFile(wb, 'Project_Count_Data.xlsx');
    };

    return (
        <>
            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: "20px", marginBottom: "10px" }}>
                <Typography variant='h3'>Project Count</Typography>
                <Button onClick={handleExport}>Download</Button>
            </Box>
            <Grid marginTop="10px" item xs={12}>
                <TableContainer component={Paper} sx={{ border: '1px solid black', borderRadius: '1px' }}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid black' }}>No. of Project Count</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid black' }}>Male</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid black' }}>Female</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid black' }}>Total</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid black' }}>Youth</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid black' }}>Women headed</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid black' }}>Ethnic</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {data?.data?.map((row: any, index: number) => (
                                <TableRow key={index}>
                                    <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid black' }}>{row.project_count}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid black' }}>{row.male || ''}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid black' }}>{row.female || ''}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid black' }}>{row.total || ''}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid black' }}>{row.youth || ''}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid black' }}>{row.women_headed || ''}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black' }}>{row.ethnic || ''}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Grid>
        </>
    );
};

export default ProjectCountTable;
